module.exports = __webpack_public_path__ + "static/media/photo_3o3_1@2x.cfa3d416.png";